import {
  QUIZ_SUBPATH,
  INTRO_SLUG,
  PUP_NAME_SLUG,
  PUP_GENDER_SLUG,
  PUP_BREED_SLUG,
  PUP_STATUS_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  RECOMMENDED_PLAN_SUBPATH,
  ADDONS_SELECTION_SUBPATH,
  CHECKOUT_SUBPATH,
  DELETE_PET_SUBPATH,
  GIFT_WITH_PURCHASE_SUBPATH,
  QUIZ_ABANDONER_MENU_SUBPATH,
  ONBOARDING_INTERSTITIAL_SLUG,
} from '../routing';

export const ROOT_SUBPATH = '/onboarding/';
export const SAMPLER_SUBPATH = '/sampler-box';
export const ALL_RECIPES = ['chicken', 'beef', 'lamb', 'turkey', 'pork'];
export const levelToLabel = {
  Low: 'mellow',
  Moderate: 'active',
  High: 'very active',
};

// Ordered onboarding milestones. QUIZ_MILESTONES / quiz progress slice from this list.
export const MILESTONES = [
  'intro',
  'pupName',
  'pupGender',
  'pupBreed',
  'pupStatus',
  'weight',
  'activity',
  'allergies',
  'recommendedPlan',
  'giftWithPurchase',
  'extras',
  'checkout',
];

const QUIZ_MILESTONE_START = 'pupName';
const QUIZ_MILESTONE_END = 'allergies';

export const QUIZ_MILESTONES = MILESTONES.slice(
  MILESTONES.indexOf(QUIZ_MILESTONE_START),
  MILESTONES.indexOf(QUIZ_MILESTONE_END) + 1,
);

export const STATE = {
  initial: ROOT_SUBPATH,
  initialSampler: SAMPLER_SUBPATH,
  intro: `${INTRO_SLUG}`,
  pupName: `${QUIZ_SUBPATH}/${PUP_NAME_SLUG}`,
  pupGender: `${QUIZ_SUBPATH}/${PUP_GENDER_SLUG}`,
  pupBreed: `${QUIZ_SUBPATH}/${PUP_BREED_SLUG}`,
  pupStatus: `${QUIZ_SUBPATH}/${PUP_STATUS_SLUG}`,
  weight: `${QUIZ_SUBPATH}/${CALORIES_SLUG}`,
  activity: `${QUIZ_SUBPATH}/${ACTIVITY_SLUG}`,
  allergies: `${QUIZ_SUBPATH}/${ALLERGIES_SLUG}`,
  interstitial: `${QUIZ_SUBPATH}/${ONBOARDING_INTERSTITIAL_SLUG}`,
  recommendedPlan: RECOMMENDED_PLAN_SUBPATH,
  giftWithPurchase: GIFT_WITH_PURCHASE_SUBPATH,
  submitCart: 'submit',
  extras: ADDONS_SELECTION_SUBPATH,
  checkout: CHECKOUT_SUBPATH,
  deletePet: DELETE_PET_SUBPATH,
  quizAbandonerMenu: QUIZ_ABANDONER_MENU_SUBPATH,
};

export const ACTION_TYPES = {
  initialLoad: 'initialLoad',
  toIntro: 'toIntro',
  toQuizAbandonerMenu: 'toQuizAbandonerMenu',
  toPupName: 'toPupName',
  toPupGender: 'toPupGender',
  toPupBreed: 'toPupBreed',
  toPupStatus: 'toPupStatus',
  toWeight: 'toWeight',
  toActivity: 'toActivity',
  toAllergies: 'toAllergies',
  toInterstitial: 'toInterstitial',
  continueFromInterstitial: 'continueFromInterstitial',
  toRecommendedPlan: 'toRecommendedPlan',
  toGiftWithPurchase: 'toGiftWithPurchase',
  toExtras: 'toExtras',
  toCheckout: 'toCheckout',
  selectedFreshRecipes: 'selectedFreshRecipes',
  selectedMixedRecipes: 'selectedMixedRecipes',
  goBack: 'goBack',
  deletePet: 'deletePet',
};

export const ACTIONS = {
  initialLoad: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.initialLoad,
    };
  },
  toIntro: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toIntro,
    };
  },
  toQuizAbandonerMenu: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toQuizAbandonerMenu,
    };
  },
  toPupName: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toPupName,
    };
  },
  toPupGender: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toPupGender,
    };
  },
  toPupBreed: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toPupBreed,
    };
  },
  toPupStatus: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toPupStatus,
    };
  },
  toWeight: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toWeight,
    };
  },
  toActivity: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toActivity,
    };
  },
  toAllergies: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toAllergies,
    };
  },
  toInterstitial: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toInterstitial,
    };
  },
  continueFromInterstitial: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.continueFromInterstitial,
    };
  },
  toRecommendedPlan: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toRecommendedPlan,
    };
  },

  toGiftWithPurchase: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toGiftWithPurchase,
    };
  },
  toExtras: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toExtras,
    };
  },
  toCheckout: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toCheckout,
    };
  },
  selectedFreshRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedFreshRecipes,
      props,
    };
  },
  selectedMixedRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedMixedRecipes,
      props,
    };
  },
  goBack: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.goBack,
    };
  },
  deletePet: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.deletePet,
    };
  },
};

const ROUTED_STATE_KEYS = [
  'intro',
  'quizAbandonerMenu',
  'pupName',
  'pupGender',
  'pupBreed',
  'pupStatus',
  'weight',
  'activity',
  'allergies',
  'recommendedPlan',
  'giftWithPurchase',
  'extras',
  'checkout',
];

//* This is a mapping of state paths to action creators. It is used to determine the action to take when a user navigates to a given state.
//* Must be kept in sync with ROUTED_STATE_KEYS and it will always begin with 'to' followed by the state key with the first letter capitalized.
export const pathToAction = Object.fromEntries(
  ROUTED_STATE_KEYS.map(stateKey => [
    STATE[stateKey],
    ACTIONS[`to${stateKey[0].toUpperCase()}${stateKey.slice(1)}`],
  ]),
);

export const unmappedStates = [
  STATE.initial,
  STATE.initialSampler,
  STATE.submitCart,
];

export const DEFAULT_SKIP_GWP_CODES = [];
